// Light/dark theme — persisted in localStorage, applied as data-theme on <html>.
// Tokens in styles.css do the rest; no per-component theming needed.
export type Theme = "light" | "dark";

const KEY = "an_admin_theme";

export function getTheme(): Theme {
  const saved = localStorage.getItem(KEY);
  if (saved === "light" || saved === "dark") return saved;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(t: Theme) {
  document.documentElement.setAttribute("data-theme", t);
}

export function setTheme(t: Theme) {
  localStorage.setItem(KEY, t);
  applyTheme(t);
}
